import React from 'react';
import ListTemplate from '../../../Reusable_Components/ListTemplate';
import { API_ROUTES, API_DOMAIN } from '../../../Reusable_Components/Config/apiConfig';
import { fmtDate } from '../../../../utils/fmt';

const QuoteTaskListDetails = () => {
  const columns = [
    { label: 'Title', value: 'title' },
    { label: 'Due Date', value: (item) => fmtDate(item.due_date) },
    { label: 'Status', value: 'status' },
    { label: 'Access Details', value: (id) => <button onClick={() => handleAccessDetails(id)}>Access Details</button> },
  ];
  const handleAccessDetails = (id) => {
    const encodedId = btoa(id);
    window.location.href = '/quote/task/details/' + encodedId;
  };
  return <ListTemplate columns={columns} onAccessDetails={handleAccessDetails} fetchUrl={API_DOMAIN + API_ROUTES['quoteTask']} />;
};

export default QuoteTaskListDetails;